import * as React from 'react';
import { Popconfirm, PopconfirmProps } from 'components';

interface TeamGroupRemovalConfirmationProps {
  canDelete?: boolean;
  popconfirmProps?: Partial<PopconfirmProps>;
  title: string;
  visible: boolean;
  handleDelete: () => Promise<void> | void;
  onCancel: () => void;
}

const TeamGroupRemovalConfirmation: React.FC<
  TeamGroupRemovalConfirmationProps
> = ({
  canDelete = true,
  children,
  popconfirmProps = {},
  title,
  visible,
  handleDelete,
  onCancel,
}) =>
  // unmount popconfirm from the DOM when not visible
  visible ? (
    <Popconfirm
      title={title}
      maxWidth="min(85vw, 350px)"
      okText="Delete"
      okButtonProps={{
        ...(!canDelete && { hidden: true }),
      }}
      cancelText={canDelete ? 'No' : 'Ok'}
      placement="topRight"
      trigger="click"
      open={visible}
      onCancel={onCancel}
      onConfirm={handleDelete}
      {...popconfirmProps}
    >
      <div>{children}</div>
    </Popconfirm>
  ) : (
    <>{children}</>
  );

export default TeamGroupRemovalConfirmation;
